/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
import { useContext, useState } from 'react';
import axios from 'axios';
import AppStateContext from '../app/context/appStateContext';
import GetCustomerContractDetails from "../functions/GetContractCustomerDetailFunction";
import GetCustomerDetails from "../functions/GetCustomerDetails";
import SysGetUsers from "../functions/SysGetUsers";

import APIHelper from "./useAPIHelper";

const LOGIN_URL = '/.netlify/functions/login';

const LoginRequest = (callback: any) => {
  const { defaultNumber, setAppStateDetails } = useContext(AppStateContext);
  const apiRunner = APIHelper();

  const [inputs, setInputs] = useState({ userName: '', password: '' });

  async function initialiseLogos() {
    let cmsResponse: [] = [];

    const logoCallback = (data: []) => {
      cmsResponse = data;
    };

    await apiRunner.run(GetCustomerDetails, logoCallback, []);

    if (cmsResponse) {
      // store all logos
      const customerMap: { [index: string]: any } = {
        default: {
          logo: '',
          number: '',
        }
      };

      cmsResponse.map((customer: any, index: number) => {
        let customerInfo: {logo: any, number: string} = {};
        customerInfo.logo = customer.data.logo.url != ''? customer.data.logo.url: '';
        customerInfo.number = customer.data.phone_number != null? customer.data.phone_number: defaultNumber;
        customerMap[customer.data.customer_id] = customerInfo;
      });
      // store map in context
      setAppStateDetails({ customerInfoMap: customerMap });
    }
  }

  async function initialiseUserInfo(userid: string) {
    let cmsResponse: {
      contractlist: {},
      roles1: {
        data: {
          permissions: [],
        }
      },
    } = {
      contractlist: {},
      roles1: {
        data: {
          permissions: [],
        }
      },
    };

    const userInfoCallback = (data: {}) => {
      cmsResponse = data;
    };

    await apiRunner.run(GetCustomerContractDetails, userInfoCallback, [userid]);

    if (cmsResponse) {
      // store all roles
      const roleArray: any[] = [];
      let contractList: {} = {};

      cmsResponse.roles1.data.permissions.map((permission: any) => {
        roleArray.push(permission.permission.uid);
        return null;
      });

      cmsResponse.contractlist.map((contract: any) => {
        contractList[contract.customercode1] = contract.contractno1[0].text
          .split(',')
          .map((item, index) => {
            return item.replace(/\s/g,'');
          });
        return null;
      });

      // store map in context
      setAppStateDetails({ userPermissionsList: roleArray, contractList: contractList });
    }
  }

  const getUserRealName = async (userName: string, token: string) => {
    let name: string = '';

    const nameCallback = (data: string) => {
      name = data;
    };

    await apiRunner.run(SysGetUsers, nameCallback,[userName, token]);

    setAppStateDetails({
      name: name,
    })
  };

  const fetchData = async () => {
    try {
      const response = await axios({
        method: 'POST',
        url: LOGIN_URL,
        headers: {
          'X-Pronto-Username': inputs.userName,
          'X-Pronto-Password': inputs.password,
        },
      });

      if (response.status === 200) {
        if (response.data.AuthInfo.token) {
          setAppStateDetails({ userId: inputs.userName, token: response.data.AuthInfo.token });
          await initialiseLogos();
          await getUserRealName(inputs.userName, response.data.AuthInfo.token);
          await initialiseUserInfo(inputs.userName);
          return true;
        }
      }
      return false;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const handleSubmit = async (event: any) => {
    if (event) {
      event.preventDefault();
      const res = await fetchData();
      callback(res);
    }
  };

  const handleInputChange = (event: any) => {
    event.persist();
    setInputs(inputChange => ({ ...inputChange, [event.target.name]: event.target.value }));
  };

  return {
    handleSubmit,
    handleInputChange,
    inputs,
  };
};

export default LoginRequest;
